



















// @ is an alias to /src
import { Component } from "vue-property-decorator";
import Dialog from "@/components/Dialog.vue";
import ErrorList from "@/components/ErrorList.vue";
import HacoCommon from "../HacoCommon";
import CoaterEditComp from "@/components/CoaterEditComp.vue";
@Component({
  components: {
    CoaterEditComp,
    Dialog,
    ErrorList
  }
})
export default class CoaterEdit extends HacoCommon {
  // put something
}
